import { apiDaInscricao } from "../../../servicos/axios";
import { ApiAgendamento } from "./buscarAgenda";

export type IniciarAtendimentoPayload = {
  agendamentoId: number;
};

export const iniciarAtendimento = async (
  agendamentoId: number
): Promise<ApiAgendamento> => {
  const api = apiDaInscricao();
  try {
    const { data } = await api.post("/agendamento/Iniciar", {
      agendamentoId,
    } as IniciarAtendimentoPayload);

    return (data?.agendamento ?? null) as ApiAgendamento;
  } catch (error: any) {
    const resp = error?.response?.data;
    const msg =
      (Array.isArray(resp?.mensagens) && resp.mensagens.join("\n")) ||
      resp?.erro ||
      resp?.mensagemDaExcecao ||
      "Erro ao iniciar atendimento.";
    throw new Error(msg);
  }
};
